<script setup lang="ts">
import { useFormValidation } from '../../../../composables/useFormValidation'
import { required } from '../../../../utils/validation'
import TextInput from '../../../../components/ui/form/TextInput.vue'
import CheckInput from '../../../../components/ui/form/CheckInput.vue'
import { api } from '../../../../api/Api'
import Toast from '../../../../services/Toast'
import { Permission } from '../../../../types/auth'
import SearchSelect from '../../../../components/ui/form/SearchSelect.vue'
import { ref, onMounted } from 'vue'
import ModalFormTemplate from '../../../../components/ui/Templates/ModalFormTemplate.vue'
import NumberInput from '../../../../components/ui/form/NumberInput.vue'
import TextAreaInput from '../../../../components/ui/form/TextAreaInput.vue'

const props = defineProps<{
  data?: any | null
  mode: 'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'
  title: string | null
  endPoint: string,
  permissions?: Permission[],
  listCreateName?: string
}>()

const emit = defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const { fields, formData, setFieldRules, validateForm, resetForm, setFormData } = useFormValidation({
  outlets_id: props.data?.outlets_id || '',
  name: props.data?.name || props.listCreateName || '',
  amount: props.data?.amount || '',
  remarks: props.data?.remarks || '',
  active: props.data?.active || true,
  uid: props.data?.uid || '',
})

setFieldRules('name', [required('Account Name is required')])
setFieldRules('amount', [required('Amount is required')])


const handleSubmit = async (close: boolean, newRecord: boolean) => {
  if (validateForm()) {
    const action = formData.value.uid != '' ? 'update' : 'create'
    const response = await api.post((props.endPoint.slice(-1) == '/' ? props.endPoint : props.endPoint + '/') + action, formData.value)
    if (response.success == true) {
      Toast.show('saved successfully')
      emit('save', response.data)
      if (close) {
        emit('close')
      } else if (newRecord) {
        resetForm()
      } else {
        setFormData(response.data)
      }
    }
  }
}

const isReadOnly = ref(true);
onMounted(() => {
  isReadOnly.value = props.mode == 'view'
  if (props.mode == 'create') {
      resetForm()
    } else if (props.data) {
      setFormData(props.data)
    }
})

</script>
<template>
  <ModalFormTemplate :data="data" :mode="mode" :title="title" :endPoint="endPoint" :perm="permissions"
    :listCreateName="listCreateName" :tabList="[]" :formData="formData" @save="handleSubmit"
    @close="$emit('close')">
    <template #form>
      <div class="grid md:grid-cols-2 gap-6">
        <SearchSelect v-model="fields.outlets_id.value" end-point="system/company/outlets"
          label="Outlet" :readonly="isReadOnly"
          :error="fields.outlets_id.touched ? fields.outlets_id.error : null"
          @blur="fields.outlets_id.touched = true" />

        <TextInput v-model="fields.name.value" label="Name" placeholder="Enter Name" :readonly="isReadOnly"
          :error="fields.name.touched ? fields.name.error : null" @blur="fields.name.touched = true" />        

      </div>
      <div class="grid md:grid-cols-3 gap-6">

        <NumberInput v-model="fields.amount.value" :readonly="isReadOnly" label="Amount"
          :error="fields.amount.touched ? fields.amount.error : null"
          @blur="fields.amount.touched = true" />

        <TextAreaInput v-model="fields.remarks.value" :readonly="isReadOnly" label="Remarks"
          :error="fields.remarks.touched ? fields.remarks.error : null"
          @blur="fields.remarks.touched = true" />

        <CheckInput v-model="fields.active.value" :readonly="isReadOnly" label="Active"
          :error="fields.active.touched ? fields.active.error : null" @blur="fields.active.touched = true" />

      </div>
    </template>
  </ModalFormTemplate>
</template>